import React from "react";

import { logger } from "@jslib/shared/utils/logger";

import { useFlag } from "@/components/FeatureFlags/hooks";

import { type VerificationService } from "../types/types";

import { isCollectStep } from "../types/runtimeTypes";

import { loadFingerprintSdk } from "./fingerprint";

/**
 * @description Pre-loads the Fingerprint SDK so it's ready at submit time.
 */
export const useFingerprint = (verificationService: VerificationService): void => {
  const fingerprintEnabled = useFlag("fingerprint-device-data") === "fingerprint-enabled";

  const { currentStep } = verificationService?.verificationResponse || {};

  React.useEffect(() => {
    if (!fingerprintEnabled || !isCollectStep(currentStep)) {
      return;
    }

    loadFingerprintSdk().catch((error) => {
      logger.error(error, "Failed to load Fingerprint SDK");
    });
  }, [fingerprintEnabled, currentStep]);
};
